import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

class OrderShow extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'orderNumber', defaultMessage: 'Ref' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'orderNumber', defaultMessage: 'Ref' });
        }
    }

    render() {
        return <div className="product-img col-md-12" />;
    }
}

export default injectIntl(OrderShow);



/** WEBPACK FOOTER **
 ** ./src/components/order/show.jsx
 **/